import { tokenManager } from './tokenManager';

export const initializeTokenManager = () => {
    // Only start monitoring if we have a valid token and not on login page
    const token = localStorage.getItem('access_token');
    const isLoginPage = window.location.pathname === '/';
    
    if (token && !isLoginPage) {
        // Check if token is still valid before starting monitoring
        const expiryString = localStorage.getItem('token_expiry');
        if (expiryString) {
            const expiryTime = new Date(expiryString);
            const now = new Date();
            
            if (now < expiryTime) {
                if (import.meta.env.VITE_DEBUG_MODE === 'true') console.log('🔄 Starting token monitoring for existing valid token');
                tokenManager.startMonitoring();
            } else {
                if (import.meta.env.VITE_DEBUG_MODE === 'true') console.log('🗑️ Clearing expired token on initialization');
                localStorage.clear();
            }
        }
    } else if (isLoginPage) {
        if (import.meta.env.VITE_DEBUG_MODE === 'true') console.log('📝 On login page - token monitoring will start after login');
    }
};

export const setupTokenManagerForLogin = (token, expiryMinutes = 500) => {
    tokenManager.setToken(token, expiryMinutes);
};
